var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goTop_conatiner",on:{"click":_vm.goTopScroll}},[_c('img',{attrs:{"src":"/assets/images/app/layout/goTop.svg","alt":"goTop"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }